import {Observable, BehaviorSubject} from 'rxjs';
import { Storage } from '@ionic/storage';

export class Store<T> {
    state$: Observable<T>;
    private _state$: BehaviorSubject<T>;

    protected _storage: Storage;
    protected _storageKey: string;

    protected constructor (initialState: T, storageKey: string, storage: Storage) {

        this._storage = storage;
        this._storageKey = storageKey;

        this._state$ = new BehaviorSubject(initialState);
        this.state$ = this._state$.asObservable();

        storage.create().then(() => {
            storage.get(storageKey).then((value) => {
                if (value) {
                    this.setState(value).then();
                }
            })
        });
    }

    get state (): T {
        return this._state$.getValue();
    }

    setState (nextState: T): Promise<void> {
        return this._storage.set(this._storageKey, nextState).then(() => {
            this._state$.next(nextState);
        });
    }
}